import { REACT_APP_THE_MOVIE_DB_API_IMAGE, REACT_APP_THE_MOVIE_DB_API_KEY, REACT_APP_THE_MOVIE_DB_API_SEARCH, REACT_APP_THE_MOVIE_DB_API_VERSION } from '../env';

require('dotenv').config();

const TheMovieDB = {
  API_V3: REACT_APP_THE_MOVIE_DB_API_VERSION,
  API_MultiSearch: REACT_APP_THE_MOVIE_DB_API_SEARCH,
  API_Img: REACT_APP_THE_MOVIE_DB_API_IMAGE,
  API_KEY: REACT_APP_THE_MOVIE_DB_API_KEY
}

export default TheMovieDB;